import { types } from 'mobx-state-tree';
import { model, Model } from 'mst-collection';
import { addMonths, format, parseISO, setDate } from 'date-fns';

import {
  TrackFeedbackStatusEnum,
  TrackFeedbackSubmitOptionEnum,
} from '@api';
import { enumerationNumber } from '@models/types';

export class TrackFeedback extends Model({
  id: types.number,
  sendingDate: types.string,
  status: enumerationNumber([
    TrackFeedbackStatusEnum.New,
    TrackFeedbackStatusEnum.Reviewed,
    TrackFeedbackStatusEnum.UnableToReview,
  ]),
  feedbackOptionType: enumerationNumber([
    TrackFeedbackSubmitOptionEnum.Credit,
    TrackFeedbackSubmitOptionEnum.Free,
  ]),
  trackLink: types.string,
}) {
  get formattedTime(): string {
    if (!this.sendingDate) {
      return '';
    }
    return format(parseISO(this.sendingDate), 'MMMM d, yyyy');
  }

  get nextDateFormattedTime(): string {
    if (!this.sendingDate) {
      return '';
    }
    return format(
      addMonths(setDate(new Date(parseISO(this.sendingDate)), 1), 1),
      'MM/dd/yyyy',
    );
  }
}

export const TrackFeedbackModel = model(TrackFeedback);
